(() => {
  const DESIGN_KEY = 'solena-custom-lighting-latest';
  const SUCCESS_KEY = 'solena-contact-last-inquiry';

  function init(root) {
    if (root.dataset.contactInitialized) return;
    root.dataset.contactInitialized = 'true';
    const form = root.querySelector('form');
    const inquiry = root.querySelector('[data-contact-inquiry]');
    if (!form || !inquiry) return;

    const groups = [...root.querySelectorAll('[data-contact-fields]')];
    const subject = root.querySelector('[data-contact-subject]');
    const body = root.querySelector('[data-contact-body]');
    const json = root.querySelector('[data-contact-json]');
    const customSummaryField = root.querySelector('[data-contact-custom-summary]');
    const submit = root.querySelector('[data-contact-submit]');
    const status = root.querySelector('[data-contact-status]');
    const savedBox = root.querySelector('[data-contact-saved-design]');
    const savedList = root.querySelector('[data-contact-design-summary]');
    let savedDesign = null;

    try {
      savedDesign = JSON.parse(localStorage.getItem(DESIGN_KEY) || 'null');
      if (!savedDesign) {
        const legacyKey = Object.keys(localStorage).find((key) => key.startsWith('solena-custom-lighting-v1-'));
        if (legacyKey) savedDesign = JSON.parse(localStorage.getItem(legacyKey) || 'null');
      }
    } catch (error) { savedDesign = null; }

    const label = (value) => String(value || '').replace(/-/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
    const designRows = () => {
      if (!savedDesign) return [];
      return [
        ['Fixture', savedDesign.fixtureType], ['Materials', Array.isArray(savedDesign.materials) ? savedDesign.materials.join(', ') : savedDesign.materials],
        ['Shape', savedDesign.shape], ['Size', savedDesign.sizePreset], ['Finish', savedDesign.finish],
        ['Light', savedDesign.lightTemperature], ['Mounting', savedDesign.mounting], ['Quantity', savedDesign.quantity]
      ].filter((row) => row[1]);
    };

    function renderSavedDesign() {
      if (!savedBox || !savedList || !savedDesign) return;
      savedList.replaceChildren(...designRows().map(([key, value]) => {
        const row = document.createElement('div'); const dt = document.createElement('dt'); const dd = document.createElement('dd');
        dt.textContent = `${key}:`; dd.textContent = label(value); row.append(dt, dd); return row;
      }));
      savedBox.hidden = false;
    }

    function activate(value) {
      groups.forEach((group) => {
        const active = group.dataset.contactFields === value;
        group.hidden = !active;
        group.querySelectorAll('input, select, textarea').forEach((field) => {
          field.disabled = !active;
          field.required = active && field.hasAttribute('data-dynamic-required');
        });
      });
      if (value === 'Custom Lighting') renderSavedDesign();
    }

    inquiry.addEventListener('change', () => activate(inquiry.value));
    root.querySelector('[data-contact-remove-design]')?.addEventListener('click', () => {
      savedDesign = null; savedBox.hidden = true;
    });

    form.addEventListener('submit', (event) => {
      activate(inquiry.value);
      if (!form.checkValidity()) {
        event.preventDefault(); form.reportValidity();
        if (status) status.textContent = 'Please complete the required fields above.';
        return;
      }
      const values = {};
      new FormData(form).forEach((value, key) => {
        if (!key.startsWith('contact[') || ['contact[body]', 'contact[Request JSON]', 'contact[Custom design summary]'].includes(key)) return;
        const cleanKey = key.slice(8, -1); if (value) values[cleanKey] = String(value);
      });
      const rows = Object.entries(values).map(([key, value]) => `${key}: ${value}`);
      const designText = designRows().map(([key, value]) => `${key}: ${label(value)}`).join('\n');
      if (designText) rows.push('', 'SAVED CUSTOM LIGHTING DESIGN', designText);
      if (subject) subject.value = `Contact Request - ${inquiry.value} - ${values.name || 'Customer'}`;
      if (body) body.value = rows.join('\n');
      if (json) json.value = JSON.stringify({ inquiryType: inquiry.value, fields: values, customDesign: savedDesign }, null, 2);
      if (customSummaryField) customSummaryField.value = designText;
      try { sessionStorage.setItem(SUCCESS_KEY, inquiry.value); } catch (error) { /* Optional enhancement. */ }
      if (submit) { submit.disabled = true; submit.querySelector('span').textContent = 'Sending...'; }
    });
    activate(inquiry.value);
  }

  document.querySelectorAll('[data-solena-contact-root]').forEach(init);
  document.querySelectorAll('[data-contact-shortcut]').forEach((shortcut) => shortcut.addEventListener('click', () => {
    const root = document.querySelector('[data-solena-contact-root]'); const inquiry = root?.querySelector('[data-contact-inquiry]');
    if (!inquiry) return; inquiry.value = shortcut.dataset.contactShortcut; inquiry.dispatchEvent(new Event('change', { bubbles: true }));
  }));
  const successType = document.querySelector('[data-contact-success-type]');
  if (successType) { try { const type = sessionStorage.getItem(SUCCESS_KEY); if (type) { successType.textContent = `Inquiry type: ${type}`; successType.hidden = false; sessionStorage.removeItem(SUCCESS_KEY); } } catch (error) { /* Optional enhancement. */ } }
})();
